(() => {
  const mountSlideshow = (root) => {
    if (root.dataset.splideReady || typeof Splide === 'undefined') return;
    root.dataset.splideReady = 'true';

    new Splide(root, {
      type: 'fade',
      rewind: true,
      autoplay: root.dataset.autoplay === 'true',
      interval: Number(root.dataset.delay) || 6000,
      pauseOnHover: false,
      pauseOnFocus: true,
      arrows: false,
      pagination: true,
      drag: true,
      keyboard: 'focused',
      speed: 800,
      label: 'Hero slideshow'
    }).mount();
  };

  const mountWithin = (container) => {
    if (container instanceof Element && container.matches('[data-hero-slideshow]')) {
      mountSlideshow(container);
    }
    container.querySelectorAll('[data-hero-slideshow]').forEach(mountSlideshow);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin(document));
  } else {
    mountWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) mountWithin(event.target);
  });
})();
